import { useStarterDashboardV2PageData } from '#src/app/pages/starterDashboardV2/pageContext';

type UsePetitionOverviewReturn = ModelHookResult<{
	comments: number;
	commentsFormatted: string;
	promoters: number;
	promotersFormatted: string;
	shares: number;
	sharesFormatted: string;
	shouldShowPromotions: boolean;
	signaturesToGoal: number;
	signaturesToGoalFormatted: string;
	supporters: number;
	supportersFormatted: string;
	views: number;
	viewsFormatted: string;
}>;

export function usePetitionStats(): UsePetitionOverviewReturn {
	const {
		data: { petition },
	} = useStarterDashboardV2PageData();

	return {
		data: {
			// TODO: hook up comments
			comments: 0,
			commentsFormatted: '0',
			promoters: petition.promotionStats?.promoterCount || 0,
			promotersFormatted: petition.promotionStats?.promoterCountLocalized || '0',
			shares: petition.sharesConnection.estimatedTotalCount,
			sharesFormatted: petition.sharesConnection.estimatedTotalCountLocalized,
			shouldShowPromotions: petition.promotable || (petition.promotionStats?.promoterCount ?? 0) > 0,
			signaturesToGoal: petition.signatureState.signatureTarget,
			signaturesToGoalFormatted: petition.signatureState.signatureTargetLocalized,
			supporters: petition.signatureState.signatureCount.displayed,
			supportersFormatted: petition.signatureState.signatureCount.displayedLocalized,
			views: petition.totalViews,
			viewsFormatted: petition.totalViewsLocalized,
		},
	};
}
